'use client';

import { useEffect, useState } from 'react';

import { useApolloClient, useQuery } from '@apollo/client/react';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { WidgetsApp } from '../../../components';
import { Types } from '@scorenco/core';
import { WeekEventsWidget } from '../../../components/Widgets';
import { resolveClubId } from '../../../utils/clubIdResolver';
import { GetClubWidgetSettingsDocument } from '../../_internal/Widget.query.generated';

const WeekEvents = () => {
  const router = useRouter();
  const client = useApolloClient();
  const [resolvedClubId, setResolvedClubId] = useState<number>();

  // Pour les widgets MonSiteClub avec l'ancien ID
  useEffect(() => {
    if (router.query.clubId) {
      resolveClubId(router.query.clubId, client)
        .then(setResolvedClubId)
        .catch(console.error);
    }
  }, [router.query.clubId, client]);

  const getClubSettings = useQuery(GetClubWidgetSettingsDocument, {
    variables: {
      clubId: resolvedClubId!,
    },
    skip: !resolvedClubId,
    context: {
      role: 'anonymous',
    },
  });

  return (
    <WidgetsApp
      widget={{
        __typename: 'widgets_widget',
        id: 0,
        settings: getClubSettings.data?.widgets_club_settings?.[0] as
          | Types.Widgets_Club_Settings
          | undefined,
      }}
      noAds
    >
      <WeekEventsWidget
        teams={[]}
        clubId={resolvedClubId}
        daySwitch={'monday'}
        eventsAwayHome={'all'}
      />
    </WidgetsApp>
  );
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'fr', [
      'snc-components',
      'snc-core',
      'common',
    ])),
  },
});

export default WeekEvents;
